import { createSelector } from '@ngrx/store';
import { TMachineMaintenanceState } from '../reducers';
import { TConfigSetupState } from './config-setup.models';

export const getConfigSetupState = (state: TMachineMaintenanceState) => state.configSetupInfo;

export const getHolidayListInfo = createSelector(
  getConfigSetupState,
  (state: TConfigSetupState) => state.holidayListingInfo,
);

export const getHolidayListPagination = createSelector(
  getConfigSetupState,
  (state: TConfigSetupState) => state.holidayListingPagination,
);
